import type { Key, ReactNode } from 'react';
import { Tabs as HeroTabs, Tab as HeroTab } from '@heroui/react';

export interface TabItem {
  key: string;
  title: ReactNode;
  content: ReactNode;
  disabled?: boolean;
}

/**
 * Design-system Tabs. Data-driven wrapper over HeroUI Tabs with our default
 * underlined/primary styling. For URL-synced tabs, pass `selectedKey`/`onChange`.
 */
export function Tabs({ items, selectedKey, onChange, ariaLabel = 'Tabs' }: {
  items: TabItem[];
  selectedKey?: string;
  onChange?: (key: string) => void;
  ariaLabel?: string;
}) {
  return (
    <HeroTabs
      aria-label={ariaLabel}
      variant="underlined"
      color="primary"
      selectedKey={selectedKey}
      onSelectionChange={onChange ? (k: Key) => onChange(String(k)) : undefined}
      disabledKeys={items.filter((i) => i.disabled).map((i) => i.key)}
    >
      {items.map((item) => (
        <HeroTab key={item.key} title={item.title}>
          <div className="pt-4">{item.content}</div>
        </HeroTab>
      ))}
    </HeroTabs>
  );
}
